import template from './peertopeer.html';
import controller from './peertopeer.controller';

let peertopeerComponent = {
  bindings: {
    customerProducts: '<',
    products: '<'
  },
  template,
  controller
};

export default peertopeerComponent;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/peertopeer.component.js